import axios from "axios";
import { IMobilePrefix } from "../../types";

export const getMobilePrefixes = async (): Promise<IMobilePrefix[]> => {
    const response = await axios.get('/booking/instool/prefix');
    return response.data;
};

export default getMobilePrefixes;